import s from './FaelleKennzahlen.module.scss'

/**
 * Die vier Zahlen über der Liste: offen, mit hoher Wirkung, fällig, in
 * sieben Tagen bewegt. Eine Zeile, keine Karten — die Liste ist die Sache,
 * die Zahlen sind ihr Rahmen. Ein Strich, wo die Zahl nicht zu holen war.
 */
export function FaelleKennzahlen({ offen, hoch, faellig, bewegt }: {
  offen: number | null
  hoch: number | null
  faellig: number | null
  bewegt: number | null
}) {
  const zahl = (n: number | null) => n === null ? '–' : String(n)
  return (
    <div className={s.zeile}>
      <span><b>{zahl(offen)}</b> offen</span>
      <span><b className={s.bad}>{zahl(hoch)}</b> Wirkung ≥ 3</span>
      <span><b className={s.warn}>{zahl(faellig)}</b> fällig</span>
      <span><b>{zahl(bewegt)}</b> bewegt 7 Tg</span>
    </div>
  )
}
